/* tslint:disable */
/* eslint-disable */
/**
 * Hermes Console
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * versions
 * @export
 * @interface VersionsResponse
 */
export interface VersionsResponse {
    /**
     * 
     * @type {string}
     * @memberof VersionsResponse
     */
    build?: string;
    /**
     * 
     * @type {string}
     * @memberof VersionsResponse
     */
    version?: string;
    /**
     * 
     * @type {boolean}
     * @memberof VersionsResponse
     */
    dummyEnabled?: boolean;
}

export function VersionsResponseFromJSON(json: any): VersionsResponse {
    return VersionsResponseFromJSONTyped(json, false);
}

export function VersionsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): VersionsResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'build': !exists(json, 'build') ? undefined : json['build'],
        'version': !exists(json, 'version') ? undefined : json['version'],
        'dummyEnabled': !exists(json, 'dummy_enabled') ? undefined : json['dummy_enabled'],
    };
}

export function VersionsResponseToJSON(value?: VersionsResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'build': value.build,
        'version': value.version,
        'dummy_enabled': value.dummyEnabled,
    };
}


